'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import Panel from '@/app/_components/Panel';
import FormError from '@/app/_components/FormError';
import SubmitWithPendingButton from '@/app/_components/SubmitWithPendingButton';
import sendPasswordResetLinkAction from '@/app/_lib/actions/SendPasswordResetLinkAction';
const resetPasswordSchema = z.object({
  account_id: z.string().min(1, 'Email is required').email('Please enter a valid email')
});
const SendPasswordResetLinkForm = () => {
  const $ = _c(31);
  const [serverError, setServerError] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      resolver: zodResolver(resetPasswordSchema),
      defaultValues: {
        account_id: ""
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    register,
    handleSubmit,
    formState: t1
  } = useForm(t0);
  const {
    errors,
    isSubmitting
  } = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async data => {
      setServerError(null);
      const response = await sendPasswordResetLinkAction(data);
      if (!response.success) {
        setServerError(response.message || response.errors?.account_id || "An error occurred");
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onSubmit = t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-between mb-4"><span className="text-semi-dark font-medium text-md">Reset Your Password</span><Link href="/account/login" className="text-sm text-primary font-medium">Sign In</Link></div>;
    t4 = <p className="block mb-4 text-sm">Please provide us with your email address and we will send you instructions for resetting your password.</p>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== handleSubmit) {
    t5 = handleSubmit(onSubmit);
    $[4] = handleSubmit;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== serverError) {
    t6 = serverError && <div role="alert" aria-live="assertive" className="text-red font-medium p-3 border-l-4 border-red mb-4">{serverError}</div>;
    $[6] = serverError;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== errors.account_id) {
    t7 = errors.account_id && <FormError id="account_id-error">{errors.account_id.message}</FormError>;
    $[8] = errors.account_id;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `form-input peer ${errors.account_id ? "border-red" : ""}`;
  const t9 = !!errors.account_id;
  const t10 = errors.account_id ? "account_id-error" : undefined;
  let t11;
  if ($[10] !== register) {
    t11 = register("account_id");
    $[10] = register;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10 || $[13] !== t11 || $[14] !== t8 || $[15] !== t9) {
    t12 = <input id="account_id" type="email" autoComplete="email" placeholder=" " className={t8} aria-invalid={t9} aria-describedby={t10} {...t11} />;
    $[12] = t10;
    $[13] = t11;
    $[14] = t8;
    $[15] = t9;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <label htmlFor="account_id" className="form-input-label peer-placeholder-shown:form-input-label-placeholder-shown">Email Address <span className="text-primary">*</span></label>;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t12) {
    t14 = <div className="form-group mb-4">{t12}{t13}</div>;
    $[18] = t12;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== isSubmitting) {
    t15 = <SubmitWithPendingButton isPending={isSubmitting} pendingText="Sending..." className="btn btn-primary">Send Me the Link</SubmitWithPendingButton>;
    $[20] = isSubmitting;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Link href="/account/login" className="text-sm text-light hover:text-primary">Cancel</Link>;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t15) {
    t17 = <div className="flex items-center gap-4 mb-4">{t15}{t16}</div>;
    $[23] = t15;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== t14 || $[26] !== t17 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t18 = <Panel label={false}>{t3}{t4}<form onSubmit={t5}>{t6}{t7}{t14}{t17}</form></Panel>;
    $[25] = t14;
    $[26] = t17;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};
export default SendPasswordResetLinkForm;